import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
// import { FaRegEye } from "react-icons/fa";
// import { MdDelete } from "react-icons/md";
// import FormImageUpload from "../../components/formFields/FormImageUpload";
// import { LoadingPanel } from "../../components/layout/Loading";

import { ErrorToast } from "../../components/toast/Toasts";
import {
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";

// import { debounce } from "lodash";
import { useLocation } from "react-router-dom";
import FormImageUpload from "../../components/formFields/FormImageUpload";
import {
  DeleteServiceImage,
  getServiceByID,
  InsertUpdateServiceImage,
} from "./services/service.services";
import { setDeleteImageIndex } from "./serviceSlice";
import FormTextArea from "../../components/formFields/FormTextArea";
// import { RiImageAddLine, RiImageEditFill } from "react-icons/ri";
// import { INVALID_ID_NAME, REQUIRED_FIELD } from "../../_contstants/Messages";

const ServiceImageArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  // const gridRef = useRef<any>(null);

  const DeleteImageIndex = useAppSelector(
    (state) => state.service.DeleteImageIndex
  );
  const ServiceID = location.state?.ServiceID;
  // const loading = useAppSelector((state) => state.cms.loading);

  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        Title: "",
        Description: "",
        Image: "",
      },
    });
  }, [fieldArrayRenderProps]);

  const handleImageSave = async (index: number) => {
    const ImageIndex = fieldArrayRenderProps?.value[index];
    const ID = ImageIndex?.ID;
    const Title = ImageIndex?.Title;
    const Description = ImageIndex?.Description;
    const Image = ImageIndex?.Image;
    const ImageData = new FormData();
    if (!Title) return ErrorToast("Please Enter Title!");

    let binaryPhoto = "";
    if (typeof Image !== "string") {
      binaryPhoto = Image[0]?.getRawFile();
    }
    ImageData.append("Image", binaryPhoto);
    ImageData.append("Description", Description);
    ImageData.append("Title", Title);
    ImageData.append("ServicesID", ServiceID);
    ImageData.append("ID", ID ? ID : 0);
    const res = await dispatch(InsertUpdateServiceImage(ImageData));
    if (res?.meta?.requestStatus === "fulfilled") {
      dispatch(getServiceByID(ServiceID));
    }
  };

  // const handleOpenImage = (url: string) => {
  //   if (url && typeof url === "string") {
  //     window.open(url);
  //   }
  // };

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("delete-cms-image"));
    dispatch(setDeleteImageIndex(index));
  };
  const handleDeleteAction = React.useCallback(
    async (index: number) => {
      const ID = fieldArrayRenderProps?.value[index]?.ID;
      if (ID) {
        const response = await dispatch(DeleteServiceImage(ID));
        if (response?.meta?.requestStatus === "fulfilled") {
          fieldArrayRenderProps?.onRemove({ index: index });
          dispatch(closeDialog());
          dispatch(setDeleteImageIndex(-1));
        }
      } else {
        fieldArrayRenderProps.onRemove({ index: index });
        dispatch(closeDialog());
        dispatch(setDeleteImageIndex(-1));
      }
    },
    [fieldArrayRenderProps]
  );

  // console.log(fieldArrayRenderProps?.value)

  // const debouncedHandleAlreadyExist = useCallback(
  //   debounce(
  //     async (e: any, index: number, formRenderProps: FormRenderProps) => {
  //       if (e?.value) {
  //         const isValid = /^[A-Za-z_][A-Za-z0-9\-:._]{3,}$/.test(e.value);
  //         if (isValid) {
  //           const res = await dispatch(ImageNameIsAvailabel(e?.value));
  //           if (res.meta.requestStatus === "fulfilled") {
  //             formRenderProps.onChange(`ServicesImageDetails.${index}.IsValidName`, {
  //               value: res?.payload?.IsAlreadyExist,
  //             });
  //           }
  //         }
  //       }
  //     },
  //     500
  //   ),
  //   []
  // );

  // const handleAlreadyExist = async (
  //   e: any,
  //   index: number,
  //   formRenderProps: FormRenderProps
  // ) => {
  //   debouncedHandleAlreadyExist(e, index, formRenderProps);
  // };

  return (
    <>
      {/* {loading && <LoadingPanel gridRef={gridRef} />} */}
      {/* {fieldArrayRenderProps?.value?.length < 1 ? pushElementInarray() : null} */}
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 10px",
          }}
        >
          <Typography.h4>Service Facilities</Typography.h4>

          <Button
            fillMode={"solid"}
            themeColor={"primary"}
            onClick={pushElementInarray}
            type="button"
          >
            Add New FAcility
          </Button>
        </GridLayoutItem>
        {dialogName === "delete-cms-image" && (
          <AppDialog>
            <>
              <Typography.h5>{"Delete Facility"}</Typography.h5>
              <GridLayout>
                <GridLayoutItem>
                  <Typography.p>
                    Are you sure you want to delete this?
                  </Typography.p>
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <DialogCloseButton themeColor="error" />
                  <Button
                    fillMode={"solid"}
                    themeColor={"error"}
                    onClick={() => handleDeleteAction(DeleteImageIndex)}
                    type="button"
                  >
                    Delete
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </>
          </AppDialog>
        )}
        <GridLayoutItem>
          <GridLayout
            style={{ marginRight: 20 }}
            cols={[{ width: "50%" }, { width: "50%" }]}
            gap={{ rows: 0, cols: 10 }}
          >
            {fieldArrayRenderProps.value &&
              fieldArrayRenderProps.value.length > 0 &&
              fieldArrayRenderProps.value.map(
                (ServicesImageDetails: any, index: number) => (
                  <GridLayoutItem key={index}>
                    <Card className="fieldarray-card-imageArray">
                      <GridLayout
                        style={{ marginRight: 20, padding: 10 }}
                        gap={{ rows: 0, cols: 10 }}
                        cols={[
                          { width: "40%" },
                          { width: "40%" },
                          { width: "20%" },
                        ]}
                      >
                        <GridLayoutItem colSpan={3}>
                          <Field
                            heightWidth={60}
                            name={`ServicesImageDetails.${index}.Image`}
                            // label="Image"
                            type="file"
                            accept="image/*"
                            acceptFileTypesMessage="Only JPG, PNG, and WEBP images are accepted."
                            component={FormImageUpload}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem colSpan={3} className="d-flex gap-2">
                          <Field
                            wrapperClassName="w-100"
                            name={`ServicesImageDetails.${index}.Title`}
                            label="Title"
                            placeholder="Title"
                            component={FormTextField}
                            // onChange={(e) =>
                            //   handleAlreadyExist(
                            //     e,
                            //     index,
                            //     fieldArrayRenderProps.formRenderProps
                            //   )
                            // }
                            validator={
                              fieldArrayRenderProps.value[index]?.Image
                                ?.length < 1 ||
                              typeof fieldArrayRenderProps.value[index]
                                ?.Image === "string"
                                ? skipValidator
                                : requiredValidator
                            }
                            astrike={
                              fieldArrayRenderProps.value[index]?.Image
                                ?.length < 1 ||
                              typeof fieldArrayRenderProps.value[index]
                                ?.Image === "string"
                                ? false
                                : true
                            }
                          />
                        </GridLayoutItem>
                        <GridLayoutItem colSpan={3}>
                          <Field
                            wrapperClassName="w-100"
                            name={`ServicesImageDetails.${index}.Description`}
                            label="Description"
                            placeholder="Description"
                            // validator={
                            //   fieldArrayRenderProps.value[index]?.Image
                            //     ?.length < 1 ||
                            //   typeof fieldArrayRenderProps.value[index]
                            //     ?.Image === "string"
                            //     ? skipValidator
                            //     : requiredValidator
                            // }
                            // astrike={
                            //   fieldArrayRenderProps.value[index]?.Image
                            //     ?.length < 1 ||
                            //   typeof fieldArrayRenderProps.value[index]
                            //     ?.Image === "string"
                            //     ? false
                            //     : true
                            // }
                            component={FormTextArea}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem
                          colSpan={3}
                          style={{
                            marginTop: 10,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              gap: 10,
                            }}
                          >
                            <Button
                              type="button"
                              fillMode={"solid"}
                              themeColor={"primary"}
                              title={
                                !fieldArrayRenderProps.value[index]?.ID
                                  ? "Add Image"
                                  : "Update Image"
                              }
                              onClick={() => handleImageSave(index)}
                              disabled={
                                fieldArrayRenderProps.value[index]?.Image
                                  ?.length < 1
                                  ? true
                                  : false
                              }
                            >
                              {!fieldArrayRenderProps.value[index]?.ID
                                ? "Save"
                                : "Update"}
                            </Button>
                            <Button
                              onClick={() => handleOpenDeleteDialog(index)}
                              // disabled={fieldArrayRenderProps.value.length === 1}
                              title={"Delete Image"}
                              fillMode={"solid"}
                              themeColor={"error"}
                              type="button"
                              size={"small"}
                              // style={{ width: 32, height: 32 }}
                            >
                              Delete
                            </Button>
                          </div>
                        </GridLayoutItem>
                      </GridLayout>
                    </Card>
                  </GridLayoutItem>
                )
              )}
          </GridLayout>
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default ServiceImageArray;
